export const iconFontAwesomeEditingDeleteLeft = (
	<i className="fa-solid fa-delete-left"></i>
);
